<template>
<div>
   <!-- <div class=" d-flex justify-content-center align-items-center" :style="{ backgroundImage: 'url(\'' + require('../../assets/img/' + image) + '\')' }"
> -->
   <div class="detail d-flex justify-content-center align-items-center">
    <div class="ipsum">
    <p class="mb-0" >Lorium ipsum dolor sit amet</p>
    <h2 class="text-center mb-0">Blog Details</h2>
    </div>
</div>
</div>
</template>

<script>


export default {
   data () {
    return {
      
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/page5/banner.vue